import styled, { css } from 'styled-components'

import { Alert } from '@/components/ui/alert'

export const Root = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
  paddingBottom: theme.space['20'],
}))

export const PermissionSelectWrapper = styled.div({})

export const PermissionGrid = styled.div(({ theme }) => ({
  display: 'grid',
  gap: theme.space['16'],
  gridTemplateColumns: '1fr 1fr',
}))

export const StartEndDateGroup = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['32'],
  width: '100%',
}))

export const PermissionGrid3 = styled.div(({ theme }) => ({
  display: 'grid',
  gap: theme.space['16'],
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
}))

export const FullWidthAlert = styled(Alert)({
  alignSelf: 'stretch',
})

export const DaysList = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.space['8'],
}))

export const DayButton = styled.button<{ $isActive: boolean }>(
  ({ theme, $isActive }) => css`
    width: 4rem;
    height: 4rem;
    border-radius: ${theme.border.radius.circle};
    border: ${theme.border.size['2']} solid
      ${$isActive ? theme.colors.black : theme.colors.black300};
    background-color: ${$isActive ? theme.colors.black : 'transparent'};
    color: ${$isActive ? theme.colors.white : theme.colors.black600};
    font-weight: 500;
    font-size: 1.2rem;
    cursor: pointer;
    flex-shrink: 0;
    transition: all ${theme.transition.duration.sm};

    &:hover {
      border-color: ${theme.colors.black};
    }
  `,
)
